export default "__VITE_ASSET__BEJVLhI5__"